const isNonEmptyString = (value) => typeof value === 'string' && value.trim().length > 0

const appendMessages = (bucket, value) => {
  if (!value) return

  if (Array.isArray(value)) {
    value.forEach((item) => appendMessages(bucket, item))
    return
  }

  if (typeof value === 'object') {
    Object.values(value).forEach((item) => appendMessages(bucket, item))
    return
  }

  if (isNonEmptyString(value)) {
    bucket.push(value.trim())
  }
}

const collectCandidateMessages = (data) => {
  if (!data || typeof data !== 'object') return []

  const candidates = []
  appendMessages(candidates, data.msg)
  appendMessages(candidates, data.message)
  appendMessages(candidates, data.error)
  appendMessages(candidates, data.errors)
  appendMessages(candidates, data.data?.msg)
  appendMessages(candidates, data.data?.message)
  appendMessages(candidates, data.data?.error)
  appendMessages(candidates, data.data?.errors)
  return candidates
}

export const extractApiErrorMessage = (error, fallback = 'Something went wrong') => {
  const responseData = error?.response?.data
  const messages = collectCandidateMessages(responseData)

  if (messages.length) return messages[0]
  if (isNonEmptyString(error?.message)) return error.message.trim()
  return fallback
}

export const extractApiFieldErrors = (error) => {
  const responseData = error?.response?.data
  const rawErrors = responseData?.errors || responseData?.data?.errors

  if (!rawErrors || typeof rawErrors !== 'object' || Array.isArray(rawErrors)) {
    return {}
  }

  const normalized = {}

  Object.entries(rawErrors).forEach(([key, value]) => {
    const messages = []
    appendMessages(messages, value)
    if (messages.length) {
      normalized[key] = messages[0]
    }
  })

  return normalized
}
